// combatpro/panels/monsters/studio/MonsterStudioTemplates.js
//
// Combat PRO - MonsterStudioTemplates (Stage 63: Legacy Template System Migration).
//
// The Encounter Templates modal, a faithful migration of the legacy markup
// (#vi-st-tpl-modal, battletracker.html 13209-13217) and the legacy list renderer
// (viTplRender, 11553). It renders the saved templates read-only with Load /
// Duplicate / Delete per row, an empty-state message, and the Save Current Setup /
// Close actions - the same layout, controls, ordering, and interactions as the
// legacy. The legacy imperative innerHTML rendering (viTplRender) is replaced by
// React rendering; nothing else changes.
//
// Styling reuses existing, already-styled classes only (no new CSS): the legacy
// template modal was itself a .vi-enc-modal (same family the Preview modal uses), and
// the legacy stylesheet defined .vi-st-tpl-row / .vi-st-tpl-info / .vi-st-tpl-acts /
// .vi-st-tpl-empty as a single shared rule with their .vi-st-ver-* counterparts (the
// Versions modal classes, which are present and styled). This component therefore
// uses .vi-enc-modal for the shell and .vi-st-ver-* for the rows, reproducing the
// legacy appearance without authoring any .vi-st-tpl-* classes.
//
// The summary string is derived by the Stage 63 engine (templateSummary); the legacy
// viEsc escaping is dropped because React escapes text nodes natively. The component
// owns no state and performs no persistence or selection - it only routes clicks to
// the runtime handlers passed in as props. No DOM access, no innerHTML. No optional
// chaining. No em dash.

import React from 'react';
import { templateSummary } from '../../../monster/monsterTemplateEngine';

function MonsterStudioTemplates(props) {
  if (!props.open) { return null; }
  var templates = Array.isArray(props.templates) ? props.templates : [];

  return (
    <div
      className="vi-enc-modal"
      id="vi-st-tpl-modal"
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <div className="vi-enc-modal-panel" style={{ width: '600px', height: 'auto', maxHeight: '82vh' }}>
        <div className="vi-enc-modal-head">
          <div>
            <div className="vi-enc-modal-title">📋 Encounter Templates</div>
            <div className="vi-enc-modal-sub">Save and reload monster line-ups</div>
          </div>
          <button type="button" className="vi-enc-modal-x" onClick={props.onClose}>{'\u00d7'}</button>
        </div>
        <div className="vi-enc-modal-body">
          <div id="vi-st-tpl-body">
            {templates.length === 0 ? (
              <div className="vi-st-ver-empty">
                No templates yet. Set up monsters in an encounter, then Save Current Setup.
              </div>
            ) : (
              templates.map(function(t, i) {
                var summary = templateSummary(t.entries);
                return (
                  <div className="vi-st-ver-row" key={(t && t.id) || i}>
                    <div className="vi-st-ver-info">
                      <b>{t.name}</b>
                      <span>{summary}</span>
                    </div>
                    <div className="vi-st-ver-acts">
                      <button type="button" className="vi-st-primary" onClick={function() { props.onLoad(i); }}>Load</button>
                      <button type="button" onClick={function() { props.onDuplicate(i); }}>Duplicate</button>
                      <button type="button" className="vi-st-danger" onClick={function() { props.onDelete(i); }}>Delete</button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div className="vi-enc-modal-actions">
          <button type="button" className="vi-enc-modal-cancel vi-st-primary" onClick={props.onSaveCurrent}>💾 Save Current Setup</button>
          <button type="button" className="vi-enc-modal-cancel" onClick={props.onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default MonsterStudioTemplates;
